export const getPlainTextLength = (html: string): number => {
  if (!html) return 0;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent?.trim().length ?? 0;
};
